<template>
  <div class="name_box">
    <div class="name_top">
      <li class="item" v-for="(item, index) in nameList" :key="index">
        {{ item.name }}<span>{{ item.num }}</span>
      </li>
    </div>

    <div class="ceri_name">
      <li class="item" v-for="(item, index) in ceriNameList" :key="index">
        <span>{{ item.num }}</span> {{ item.name }}
      </li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    nameList: Array,
    ceriNameList: Array,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>

</style>